// src/components/AIChatInput.jsx
// Chat input with auto-resize textarea. Enter sends, Shift+Enter for newline.

import React, { useState, useRef, useEffect } from 'react';
import { Send } from 'lucide-react';

export default function AIChatInput({ onSend, disabled, placeholder }) {
  const [text, setText] = useState('');
  const textareaRef = useRef(null);

  // Auto-resize textarea
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 120) + 'px';
  }, [text]);

  const handleSend = () => {
    if (!text.trim() || disabled) return;
    onSend(text.trim());
    setText('');
    // Reset height after clear
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="p-3 border-t border-slate-200 dark:border-slate-800 flex-shrink-0">
      <div
        className={`flex items-end gap-2 bg-slate-50 dark:bg-slate-800/60 border rounded-2xl px-3 py-2 transition-all
        ${disabled
          ? 'border-slate-200 dark:border-slate-700 opacity-60'
          : 'border-slate-200 dark:border-slate-700 focus-within:border-indigo-400 dark:focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20 focus-within:bg-white dark:focus-within:bg-slate-800'}`}
      >
        <textarea
          ref={textareaRef}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder || 'Ask about this deal...'}
          aria-label="Chat message"
          disabled={disabled}
          rows={1}
          className="flex-1 bg-transparent text-slate-900 dark:text-slate-100 text-sm resize-none outline-none placeholder-slate-400 dark:placeholder-slate-500 min-h-[20px] max-h-[120px]"
        />
        <button
          onClick={handleSend}
          disabled={disabled || !text.trim()}
          className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg transition-colors
            ${
              text.trim() && !disabled
                ? 'bg-indigo-600 hover:bg-indigo-500 text-white'
                : 'bg-slate-200 dark:bg-slate-700 text-slate-400 dark:text-slate-500 cursor-not-allowed'
            }`}
        >
          <Send size={14} />
        </button>
      </div>
      {disabled && (
        <p className="text-[11px] text-slate-500 dark:text-slate-500 mt-1 text-center">Waiting for response...</p>
      )}
    </div>
  );
}
